import { memo } from 'react';

interface SevenSegmentProps extends React.SVGProps<SVGGElement> {
  digits: number,
  number: number,
}

const map = {
  0: [1, 1, 1, 0, 1, 1, 1],
  1: [0, 0, 0, 0, 0, 1, 1],
  2: [0, 1, 1, 1, 1, 1, 0],
  3: [0, 0, 1, 1, 1, 1, 1],
  4: [1, 0, 0, 1, 0, 1, 1],
  5: [1, 0, 1, 1, 1, 0, 1],
  6: [1, 1, 1, 1, 1, 0, 1],
  7: [0, 0, 1, 0, 0, 1, 1],
  8: [1, 1, 1, 1, 1, 1, 1],
  9: [1, 0, 1, 1, 1, 1, 1],
  '-': [0, 0, 0, 1, 0, 0, 0],
};

const segments = [
  <path
    key="ul"
    d="M0 21.54L0 5.67 2.26 3.41 4.52 5.67 4.52 21.54 2.26 23.8 0 21.54z"
  />,
  <path
    key="ll"
    d="M0 44.22L0 28.36 2.26 26.1 4.52 28.36 4.52 44.22 2.26 46.49 0 44.22z"
  />,
  <path
    key="ct"
    d="M3.41 2.26L5.67 0 21.54 0 23.8 2.26 21.54 4.52 5.67 4.52 3.41 2.26z"
  />,
  <path
    key="cc"
    d="M3.41 24.95L5.67 22.69 21.54 22.69 23.8 24.95 21.54 27.21 5.67 27.21 3.41 24.95z"
  />,
  <path
    key="cr"
    d="M3.41 47.63L5.67 45.34 21.54 45.34 23.8 47.63 21.54 49.9 5.67 49.9 3.41 47.63z"
  />,
  <path
    key="ur"
    d="M22.69 21.54L22.69 5.67 24.95 3.41 27.21 5.67 27.21 21.54 24.95 23.8 22.69 21.54z"
  />,
  <path
    key="lr"
    d="M22.69 44.22L22.69 28.36 24.95 26.1 27.21 28.36 27.21 44.22 24.95 46.49 22.69 44.22z"
  />,
];

export const SevenSegment: React.FC<SevenSegmentProps> = memo(({
  digits,
  number,
  ...gProps
}) => {
  const str = String(Math.abs(number)).slice(-digits).padStart(digits, '0');

  return (
    <g fill="#f9c432" {...gProps}>
      <rect fill="none" width="28" height="50" />
      {number < 0 && segments[3]}
      {str.split('').map((char, i) => {
        const def = map[char as unknown as keyof typeof map];
        return (
          <g key={i} transform={`translate(${(i + 1) * 36} 0)`}>
            {segments.map((segment, j) => def[j] && segment)}
          </g>
        );
      })}
    </g>
  );
});
